// Building/structure voxel prefabs — adapted from adventure-craft.
//
// Split by group; this file is the registry that assembles them (key order is
// part of the public `buildingPrefabs` shape):
//   buildings_core.ts      house, tower, tavern, castle, temple, church, ...
//   buildings_industry.ts  mines, harbour, shipyards, grand forge
//   buildings_arcane.ts    dark shrine, mana font, observatory, portals
//   buildings_shared.ts    `box()` and `hollowBox()` builders
import { darkShrine, manaFont, observatory, portalDark, portalLight } from './buildings_arcane.js';
import {
  church,
  farm,
  fortress,
  house,
  market,
  smallCastle,
  tavern,
  temple,
  tower,
  workshop,
} from './buildings_core.js';
import {
  crystalMine,
  darkCrystalMine,
  goldMine,
  grandForge,
  grandShipyard,
  harbour,
  ironMine,
  shipyard,
  silverMine,
} from './buildings_industry.js';
import type { StructurePrefab } from './types.js';

export const buildingPrefabs: Record<string, StructurePrefab> = {
  house,
  tower,
  tavern,
  castle: smallCastle,
  temple,
  church,
  fortress,
  workshop,
  market,
  farm,
  iron_mine: ironMine,
  silver_mine: silverMine,
  gold_mine: goldMine,
  crystal_mine: crystalMine,
  dark_crystal_mine: darkCrystalMine,
  harbour,
  shipyard,
  dark_shrine: darkShrine,
  mana_font: manaFont,
  grand_forge: grandForge,
  observatory,
  portal_light: portalLight,
  portal_dark: portalDark,
  grand_shipyard: grandShipyard,
};
